/**
 * Block component pattern for all blocks
 *
 */
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ClickEditComponent, Mode } from './clickEditModal.component';

import _upperFirst from 'lodash-es/upperFirst';
import { faTrash, faCheckCircle, faTimesCircle, IconDefinition} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'ui-array-edit',
  template: `
<div class="clickEdit"
     [class.disabled]="mode === modes.readOnly">
    <div class="popoverOpener" (click)="mode !== modes.readOnly ? toggleEditForm() : false">
      <fa-icon [icon]="icon | iconNameToDefinition" *ngIf="(icon) != ''"></fa-icon>
      <span class="formLabel"
          *ngIf="(editedList.length == 0 && editFormIsOpen == false) || formLabel == true"
          [class.formLabel]="formLabel == true"
          [class.isActive]="formIsActive == true"
          (click)="mode !== modes.readOnly ? forceFocus = true : false">
        {{ label }}
	    </span>
      <span *ngIf="(editedList.length > 0 && editFormIsOpen == false && mode !== modes.detail) || (editedList.length > 0 && formLabel == true)">
        &nbsp;:&nbsp;
      </span>
        <span *ngIf="editedList.length > 0 && (hideEditedField) == false">
          <span class="listItem" *ngFor="let editeditem of editedList; let i = index">
            <fa-icon [icon]="iconTrash" 
                     *ngIf="mode !== modes.readOnly"
                     (click)="removeItem(i)"></fa-icon>
            <span (click)="mode !== modes.readOnly ? setValue(editeditem, i) : false">{{ editeditem }}</span>
            <span *ngIf="unit.length > 0"> {{ unit }} </span>
            <i *ngIf="editedList.length > 1 && i < editedList.length - 1">,</i>
        </span>
        </span>
        <ng-content *ngIf="editedList.length > 0 && hideEditedField == true" select=".editablePlaceholder"></ng-content>
        <!-- this following input helps to simulate the focus event to
        catch for opening the tinymce form with tab navigation as example-->
        <input
        *ngIf="editFormIsOpen == false" class="hiddenInput" type="text" (focus)="toggleEditForm(); forceFocus = true">
    </div>
    <div [class.titleEditor]="(mode) == modes.head">
        <div class="popoverContainer" *ngIf="editFormIsOpen == true"
            [class.inlinePopOver]="mode == 'inline'"
            (clickOutside)="pushNewValue();">
            <div class="popoverArrow-topLeft" *ngIf="mode == modes.detail"></div>
            <form class="popoverBody">
                <i class="fa {{ icon }}" *ngIf="(icon) != '' && mode != modes.inline"></i>
                <input class="textInput"
                       [focusIf]="(mode == modes.inline ? false : true) || (forceFocus == true)"
                       (keydown)="keyAction($event);"
                       (focus)="formIsActive = true"
                       (blur)="formIsActive = false; forceFocus = false"
                       type="text"
                       [(ngModel)]="inEditionForm.value"
                       placeholder="{{ label }}"
                       name="value">
                <div class="buttonGroup buttonGroup-bottomPosition" *ngIf="(mode) == modes.detail">
                    <button class="plainButton closeButton" type="button" (click)="cancel();">
                      <fa-icon [icon]="iconTimesCircle"></fa-icon>
				</button>
                    <button class="plainButton tickButton" type="button" (click)="pushNewValue();">
                      <fa-icon [icon]="iconCheckCircle"></fa-icon>
				</button>
                </div>
                <div class="buttonGroup buttonGroup-topPosition" *ngIf="(mode) == modes.head">
                    <button class="plainButton closeButton" type="button" (click)="cancel();">
                      <fa-icon [icon]="iconTimesCircle"></fa-icon>
					{{ t_cancel }}
				</button>
                    <button class="plainButton tickButton" type="button" (click)="pushNewValue();">
                      <fa-icon [icon]="iconCheckCircle"></fa-icon>
					{{ t_valid }}
				</button>
                </div>
            </form>
        </div>
    </div>
  `,
  styles: [`
    .hide{
      display: none;
    }
    input.hiddenInput{
      opacity: 0;
      height:0;
      width: 0;
    }
    .formLabel{
      display: inline-block;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      color: #8d8d8d;
    }
    i.fa{
        color: #8d8d8d;
    }
    .formLabel.isActive{
      border-bottom: 2px solid #EF4F2F;
      opacity: 1;
      font-weight: bolder;
    }
    .listItem{
      opacity: 0.8;
    }
    .listItem i.fa{
      opacity: 0;
    }
    .listItem:hover{
      opacity: 1;
    }
    .listItem:hover i.fa{
      opacity: 1;
    }
    `]
})

export class ArrayEditComponent extends ClickEditComponent{

  @Input()
  public formName:string;
  @Input()
  public mode:Mode = Mode.detail;
  public modes: typeof Mode = Mode;
  @Input()
  public icon:string = "";
  @Input()
  public unit:string = "";
  @Input()
  public hideEditedField:boolean = false;
  @Input()
  public label:string;
  @Input()
  public formLabel:boolean = false;
  @Input()
  public editableValue:any = [];

  @Output()
  public returnedValue:EventEmitter<string> = new EventEmitter();

  public iconCheckCircle: IconDefinition = faCheckCircle;
  public iconTimesCircle: IconDefinition = faTimesCircle;
  public iconTrash: IconDefinition = faTrash;

  /**
   * LIVECYCLE
   */
  constructor() {
      super();
  }

  /**
   * for Each field when opening the page
   *
   */
  public ngOnInit(){
      this.label = _upperFirst(this.label);
      if (this.editableValue !== '' || this.editableValue.length > 0) {
          this.resetInEditionForm();
          this.editedList = this.editableValue;
          this.tempValue = this.editableValue;
      }else{
          this.resetInEditionForm();
          this.editedList = [];
          this.tempValue = [];
      }
  }

  public ngOnChanges(simpleChanges: SimpleChanges){
      if (this.editableValue !== '' && this.formName !== 'blockToHide') {
          this.editedList = simpleChanges.editableValue.currentValue;
          this.tempValue = simpleChanges.editableValue.currentValue;
      }else{
          this.tempValue = [];
      }
  }

  public tempValue:any = [];
  public doFocus:string = "";
  public formIsActive: boolean = false;
  public editedList: any = [];
  public inEditionForm:any = {
    'value': ''
  };

  public editedIndex: number = -1; //default value : -1 for a new item

  /**
   * returnForm
   * Return the form Content editedList to the output returnedValue
   * As to be launched each time the value need to be catch
   */
  public returnForm():void{
    this.returnedValue.emit(this.editedList);
  }

  /**
   * toggleEditForm
   *
   * Show/Hide form
   * @param {boolean} bool : true to show, false to hide
   */
  public toggleEditForm(bool?:boolean):void{
    if (!bool) {
      this.editFormIsOpen = (this.editFormIsOpen === true) ? this.editFormIsOpen = false : this.editFormIsOpen = true;
      if (this.formName && this.editFormIsOpen === true) {
        this.doFocus = this.formName;
      }
    }else{
      this.editFormIsOpen = bool;
    }
    if (this.editFormIsOpen === true) {
      this.forceFocus = true;
    }
  }

  /**
   * removeItem
   *
   * Remove an item from the Array
   * @param {number} index : value index
   */
  public removeItem(index:number):void{
    this.editedList.splice(index, 1);
    this.toggleEditForm();
    this.returnForm();
  }


  /**
   * removeItem
   *
   * Empty field, set a New Item
   * @param {number} index : value index
   */
  public resetInEditionForm(): void{
    this.editedIndex = -1; //always set to new item after deleting
    this.forceFocus = true;
    this.inEditionForm.value = '';
  }

  /**
   * setValue
   *
   * FIXME : [EJ] think ther a bug there, when click in a field with tab values already given
   * @param {string} newValue : the value the user have just typped
   * @param {number} editedIndex : on click on an item for Array, get is Index to modify
   */
  public setValue(newValue:string, editedIndex: number):void{
    this.inEditionForm.value = newValue;
    this.editedIndex = editedIndex;
    this.forceFocus = true;
  }

  /**
   * pushNewValue
   *
   * push the Value in editedList Array, only if field is not empty
   */
  public pushNewValue():void{
    if (this.inEditionForm.value === '') { //if empty,
      this.returnForm();
      this.toggleEditForm(false);
    }else{ //if Not empty
      if(this.editedIndex === -1){
        this.editedList.push(this.inEditionForm.value);
      }else{
        this.editedList[this.editedIndex] = this.inEditionForm.value;
      }
      this.returnForm();
      this.resetInEditionForm();
    }
  }

  /**
   * keyAction
   *
   * catch key
   * @param {any} event : key pressed
   */
  public keyAction(event:any):void{
    if (event.key === 'Tab') { // If Tab, push, return and toggle
      this.pushNewValue();
      this.toggleEditForm(false);
    }
    if (event.key === 'Enter') { // If Enter, only push
      this.pushNewValue();
    }
  }

}
